<template>
  <div>
    <v-card>
      <v-data-table
        dense
        :headers="headers"
        :items="calculationsData"
        :server-items-length="pagination.itemsLength"
        :options.sync="pagination"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [25, 50, 100],
        }"
        loading-text="Считываем данные ..."
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <!-- <v-toolbar-title>Расчеты сотрудников</v-toolbar-title> -->
            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
            <!-- <v-spacer></v-spacer> -->
            <div class="grids">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Найти"
                hide-details
                clearable
              />
              <v-select
                v-model="selectedUser"
                :items="userList"
                item-text="user_name"
                item-value="user_id"
                label="Сотрудник"
              />
            </div>
          </v-toolbar>
        </template>
        <template v-slot:item.numberlot="{ item }">
          <div v-if='item.purchase_number'>
              <a
              class="bluelink"
              @click.prevent="getCustomerinfoForMyCalculations(item)"
            >
              {{ item.purchase_number }}
            </a>
            <!-- <v-icon style="float: right" class="mr-2">edit</v-icon> -->
            <br />
            <span >Лот: {{ item.lot_number }}</span>
            <template v-if="item.smp == 'да'">
              <span class="ml-2" style="color: red">СМП</span>
            </template>
          </div>
          <div v-else>
            N/A
          </div>
        </template>
        <template v-slot:item.zakgar="{ item }">
          {{ purchasesIdToSting(item.purchase) }}
          <br />
          {{ quaranteesIdToString(item.quarantee) }}
        </template>
        <template v-slot:item.data="{ item }">
          {{ item.data }}
        </template>
        <template v-slot:item.bg="{ item }">
          {{ addCommas(item.summ) }} ₽
          <br />
          с {{ moment(item.date_from).format("DD.MM.YYYY") }} <br /> по {{ moment(item.date_to).format("DD.MM.YYYY") }} <br /> на {{ item.days }} дн.
        </template>
        <template v-slot:item.client_innname="{ item }">
          <div v-if='item.client_inn || item.client_name'>
            {{item.client_inn}} | {{item.client_name}}
          </div>
          <div v-else>N/A</div>
        </template>
        <template v-slot:item.winner_innname="{ item }">
          <div v-if='item.customer_inn || item.customer'>
            {{ item.customer_inn }} | {{ item.customer }}
          </div>
          <div v-else>
            <span>N/A</span>
          </div>
        </template>
        <template v-slot:item.user="{ item }">
          {{ getUserName(item) }}
          <br />
          {{ moment(item.updatedAt).format("HH:mm DD.MM.YYYY") }}
        </template>
        <template v-slot:item.actions="{ item }">
          <template v-if="item.user_id == 24">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  :loading="false"
                  icon
                  @click="deleteCalculation(item)"
                >
                  <v-icon v-on="on">delete</v-icon>
                </v-btn>
              </template>
              <span>Удалить расчет</span>
            </v-tooltip>
          </template>
          &nbsp;
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn small :loading="false" icon @click="sendToCalc(item)">
                <v-icon v-on="on">fa fa-calculator</v-icon>
              </v-btn>
            </template>
            <span>Переход в калькулятор</span>
          </v-tooltip>

          &nbsp;
          <v-tooltip bottom v-if="item.table">
            <template v-slot:activator="{ on }">
              <v-btn
                small
                :loading="false"
                icon
                @click="sendToCalcResult(item)"
              >
                <v-icon v-on="on">fa fa-eye</v-icon>
              </v-btn>
            </template>
            <span>Переход к расчету</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import headers from './calcRegister/calcHeaders'

export default {
  watch: {
    search() {
      this.getData();
    },
    selectedUser() {
      this.getData();
    },
    "pagination.page": {
      handler() {
        this.getData();
      },
      // deep: true,
    },
  },
  async mounted() {
    // const RegionsRE = this.$store.getters.getRegionRe;
    // if (!RegionsRE.length) {
    //   this.$store.dispatch("getRegionsRe");
    // }
    await this.getData();
    await this.init();
  },

  data: ()=>({
      moment,
      search: "",
      calculationsData: [],
      userList: [],
      loading: false,
      selectedUser: null,
      pagination: {
        page: 1,
        itemsPerPage: 25,
        itemsLength: 0,
      },
      headers,
    }),
  methods: {
    deleteCalculation(item) {
      this.loading = true;
      this.$store
        .dispatch("deleteMyCalculation", item.id)
        .then(() => {
          this.calculationsData = this.$store.getters.getCalculationsData;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    async init() {
      const users = await this.getUsersList()
      const uniqNames = new Array();
      uniqNames.unshift({ user_id: null, user_name: "Без фильтра" });

      for (const user of users) {
        if (Number(user.user_id) !== Number(this.$store.getters.user_id)) {

          uniqNames.push({
            user_id: user.user_id,
            user_name: user.fio ? user.fio : user.profile_name ? user.profile_name : user.name,
          });
        }
      }

      this.userList = uniqNames;
    },
    getUserName(item){


      const user = this.userList.filter((row) => row.user_id == item.user_id);

      if(user && user[0]){
        return user[0].user_name
      }else{
       return 'Пользователь удален'
      }
    },

    async getData() {
      this.loading = true;
      this.calculationsData = [];

      const getObj = {
        // user_id: Number(this.$store.getters.user_id),
        firm_id: Number(this.$store.getters.getMyOrganisation.id),
        page: this.pagination.page,
        itemsPerPage: this.pagination.itemsPerPage,
        selectedUser: this.selectedUser,
        search: this.search,
      };

      const res = await this.$store.dispatch(
        "getAllUsersCalculationsData",
        getObj
      );

      this.pagination.itemsLength = res.itemsLength;
      this.calculationsData = res.data;
      this.loading = false;
    },
    getCustomerinfoForMyCalculations(data) {
      this.$store.commit("SET_CUSTOMER_INFO_INN", data.customer_inn);
      this.$store.commit("SET_CUSTOMER_INFO_NAME", data.customer_name);
      this.$store.commit("SET_CUSTOMER_INFO_TITLE", data.title);
      this.$store.commit("SET_SHOW_WINNERS_CUSTOMER_WINDOW", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.grids {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
}
.v-select {
  height: 32px;
}
</style>
